/* ============================================================
   CasaFab — Configurateur de chambre
   Les cartes sont rendues par Liquid ; ce script ne construit
   aucun DOM produit : il met à jour des attributs et bascule
   des éléments. Ça préserve le focus clavier, le SEO, et les
   apps qui scannent le DOM au chargement (Loox, ReelUp…).
   ============================================================ */
(function () {
  'use strict';
  if (customElements.get('casafab-room-builder')) return;

  var RM = window.matchMedia('(prefers-reduced-motion:reduce)');

  customElements.define('casafab-room-builder', class extends HTMLElement {

    /* ---------- cycle de vie ---------- */
    connectedCallback() {
      this.currency = this.dataset.currency || 'EUR';
      this.locale = (document.documentElement.lang || 'fr-FR').replace('_', '-');
      this.money = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency });
      this.nightstandDiscountCode = 'CASAFABRIQUE15';
      this.cartAddUrl = this.dataset.cartAdd || '/cart/add.js';
      this.cartUrl = this.dataset.cartUrl || '/cart';
      this.roomId = 'rb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

      this.S = { size: null, bed: null, bedColor: 0, mattress: null, skipM: false, ns: null, nsQty: 1, skipNs: false, nsChoice: 'auto',
                 fStore: 'all', fMat: 'all', fAva: 'all', colors: {}, photos: {} };

      this.$ = (s) => this.querySelector(s);
      this.$$ = (s) => Array.prototype.slice.call(this.querySelectorAll(s));

      this.mobileLimit = 6;
      this.dataset.mobileStep = 'size';
      this.storageKey = 'casafab-room:' + this.dataset.sectionId;
      try { this.savedRoom = JSON.parse(sessionStorage.getItem(this.storageKey)); } catch (_) {}
      this.readData();
      this.setupMobile();
      this.restoreRoom();
      clearInterval(this.reelWatch);
      this.reelWatch = setInterval(() => this.linkReels(), 1000);
      this.bind();
      this.setupCompactMobile();
      this.track('view');
      this.catalogReady = this.loadMoreBeds();
      this.rankingReady = this.loadSalesRanking();
      this.startReviewAutoplay();
      this.rafId = null;
      this.shown = 0;
      this.update();
    }

    disconnectedCallback() {
      this.closeMobileDetail(false);
      if (this.compactEvents) this.compactEvents.abort();
      this.sizeRequest = (this.sizeRequest || 0) + 1;
      this.cancelStepMotion();
      clearInterval(this.reelWatch);
      clearInterval(this.reviewTimer);
      if (this.mobileEvents) this.mobileEvents.abort();
      if (this.reviewEvents) this.reviewEvents.abort();
      if (this.onKey) document.removeEventListener('keydown', this.onKey);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    /* Style the live Loox widget without advancing reviews automatically. */
    startReviewAutoplay() {
      clearInterval(this.reviewTimer);
      if (this.reviewEvents) this.reviewEvents.abort();
      var enhance = () => {
        this.querySelectorAll('[data-rb-reviews]').forEach(function (section) {
          var widget = section.querySelector('loox-snippets-widget');
          var reviewRoot = widget && widget.shadowRoot;
          if (!reviewRoot) return;
          if (!reviewRoot.querySelector('[data-casafab-review-style]')) {
            var reviewStyle = document.createElement('style');
            reviewStyle.setAttribute('data-casafab-review-style', '');
            reviewStyle.textContent = "\n.quickview-button{background:#fff!important;border:1px solid #e3e8e5!important;border-radius:10px!important;box-shadow:0 2px 8px #14231b08!important;text-align:left!important;padding:14px!important;box-sizing:border-box!important}\n.element{display:flex!important;flex-direction:row-reverse!important;gap:12px!important;align-items:center!important}\n.content{display:grid!important;grid-template-columns:minmax(0,1fr)!important;gap:7px!important;min-width:0!important;flex:1!important}\n.title{display:contents!important}\n.rating{grid-row:1!important;display:flex!important;gap:2px!important;line-height:1!important}\n.rating .loox-icon{display:block!important;width:18px!important;height:18px!important;padding:3px!important;box-sizing:border-box!important;background:#e7ece9!important;color:#fff!important;fill:#fff!important;border-radius:1px!important;flex:0 0 18px!important}\n.rating .loox-icon[data-lx-fill=\"full\"]{background:#00a67d!important}\n.rating .loox-icon[data-lx-fill=\"half\"]{background:linear-gradient(90deg,#00a67d 50%,#e7ece9 50%)!important}\n.text{grid-row:2!important;color:#202722!important;font-size:13px!important;line-height:1.45!important;display:-webkit-box!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:3!important;overflow:hidden!important;font-style:normal!important;white-space:normal!important}\n.name{grid-row:3!important;font-size:12px!important;font-weight:600!important;color:#59675e!important;line-height:1.3!important}\n.image{width:58px!important;height:76px!important;min-width:58px!important;flex:0 0 58px!important;object-fit:cover!important;border-radius:6px!important}\n.arrow{border:1px solid #e3e8e5!important;background:#fff!important;color:#263e31!important;box-shadow:0 2px 6px #14231b0d!important}\n.quickview-button:focus-visible{outline:2px solid #7540ef!important;outline-offset:-3px!important}\n";
            reviewStyle.textContent += '\n@media(max-width:640px){.quickview-button{padding:10px!important}.image{height:64px!important;width:50px!important;min-width:50px!important;flex-basis:50px!important}.arrow{min-width:44px!important;min-height:44px!important}}';

            reviewStyle.textContent += '\n.grid{display:flex!important;gap:12px!important;scroll-snap-type:x mandatory!important;scroll-padding:0!important;padding-inline:0!important}.grid>.quickview-button{flex:0 0 100%!important;width:100%!important;min-width:100%!important;max-width:100%!important;margin:0!important;scroll-snap-align:start!important;height:auto!important;min-height:132px!important}.element{height:auto!important;min-height:104px!important;padding:0!important;box-sizing:border-box!important}.grid>.quickview-button{padding:12px 34px!important}.rb-review-more{grid-row:4;font-size:12px;text-decoration:underline;text-underline-offset:3px;color:#6540a1}.arrow{min-width:44px!important;min-height:44px!important}.content{gap:5px!important}';
            reviewRoot.appendChild(reviewStyle);
          }
          reviewRoot.querySelectorAll('.quickview-button .content').forEach(function (content) {
            if (!content.querySelector('.rb-review-more')) {
              var more = document.createElement('span');
              more.className = 'rb-review-more'; more.textContent = 'Lire l’avis';
              content.appendChild(more);
            }
          });
        });
      };
      enhance();
      this.reviewTimer = setInterval(enhance, 1000);
    }

    setupMobile() {
      this.mobileEvents = new AbortController();
      var signal = this.mobileEvents.signal;
      var filter = document.createElement('button');
      filter.type = 'button'; filter.className = 'rb-mobile-filter rb-btn rb-btn--g';
      filter.setAttribute('data-rb-filter-toggle', ''); filter.setAttribute('aria-expanded', 'false');
      filter.textContent = 'Filtrer';
      var bar = this.$('.rb-fbar'); bar.id = this.id + '-filters';
      filter.setAttribute('aria-controls', bar.id); bar.before(filter);
      var apply = document.createElement('button'); apply.type = 'button'; apply.className = 'rb-mobile-apply rb-btn'; apply.setAttribute('data-rb-filter-apply', ''); bar.appendChild(apply);
      var empty = document.createElement('p'); empty.className = 'rb-mattress-empty'; empty.setAttribute('data-rb-mattress-empty', ''); empty.hidden = true; this.$('[data-rb-mattress-grid]').before(empty);
      var reset = document.createElement('button');
      reset.type = 'button'; reset.className = 'rb-mobile-reset'; reset.setAttribute('data-rb-reset', '');
      reset.textContent = 'Effacer les filtres'; reset.hidden = true; filter.after(reset);
      var more = document.createElement('button');
      more.type = 'button'; more.className = 'rb-mobile-more rb-btn rb-btn--g';
      more.setAttribute('data-rb-more', ''); more.textContent = 'Voir plus de sommiers';
      this.$('[data-rb-bed-grid]').after(more);
      var skip = this.$('[data-rb-skip-mattress]');
      var skipWrap = document.createElement('div'); skipWrap.className = 'rb-optional-choice';
      skipWrap.appendChild(skip); this.$('[data-rb-mattress-grid]').before(skipWrap);
      var without = document.createElement('button');
      without.type = 'button'; without.className = 'rb-btn rb-btn--g rb-optional-choice';
      without.setAttribute('data-rb-without-ns', ''); without.textContent = 'Continuer sans chevets';
      this.$('[data-rb-ns-grid]').before(without);
      var summary = document.createElement('p'); summary.className = 'rb-mobile-summary';
      summary.setAttribute('data-rb-mobile-summary', ''); this.$('.rb-steps').appendChild(summary);
      this.addEventListener('touchstart', e => {
        if (e.target.matches('[data-rb-lb-img]') && this.LB && e.touches.length === 1) { this.swipe = { lightbox: true, x: e.touches[0].clientX, y: e.touches[0].clientY }; return; }
        var card = e.target.closest('[data-rb-bed]');
        this.cardTouch = card && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
        if (!card || !e.target.closest('.rb-card__vis') || e.touches.length !== 1) { this.swipe = null; return; }
        this.swipe = { card: card, x: e.touches[0].clientX, y: e.touches[0].clientY };
      }, { passive: true, signal: signal });
      this.addEventListener('touchend', e => {
        if (this.cardTouch && e.changedTouches.length) {
          var touch = e.changedTouches[0];
          if (Math.abs(touch.clientX - this.cardTouch.x) > 12 || Math.abs(touch.clientY - this.cardTouch.y) > 12) this.cardGestureUntil = Date.now() + 500;
        }
        this.cardTouch = null;
        var swipe = this.swipe; this.swipe = null;
        if (!swipe || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - swipe.x, dy = e.changedTouches[0].clientY - swipe.y;
        if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        if (swipe.lightbox && this.LB) { this.LB.i += dx < 0 ? 1 : -1; this.paintLb(); return; }
        var bed = this.beds.find(b => b.el === swipe.card), photos = bed && this.col(bed).imgs;
        if (!photos || photos.length < 2) return;
        this.swipeUntil = Date.now() + 500;
        this.S.photos[bed.id] = (this.photoIdx(bed) + (dx < 0 ? 1 : -1) + photos.length) % photos.length;
        this.paintBed(bed); if (this.S.bed === bed) this.update();
      }, { passive: true, signal: signal });
      this.addEventListener('touchcancel', () => { this.swipe = null; this.cardTouch = null; this.cardGestureUntil = Date.now() + 500; }, { passive: true, signal: signal });
    }

    limitMobileBeds() {
      var cards = this.$$('[data-rb-bed-grid] > [data-rb-bed]').filter(e => !e.hidden);
      cards.forEach((el, index) => el.classList.toggle('rb-mobile-deferred', index >= this.mobileLimit && !(this.S.bed && this.S.bed.el === el)));
      var more = this.$('[data-rb-more]');
      if (more) {
        more.hidden = cards.length <= this.mobileLimit;
        more.textContent = 'Voir plus de sommiers (' + Math.max(0, cards.length - this.mobileLimit) + ')';
      }
      var apply = this.$('[data-rb-filter-apply]'); if (apply) apply.textContent = 'Voir les ' + cards.length + ' modèles';
      var active = this.$$('[data-rb-filter].is-on').filter(e => e.dataset.rbFilter !== 'all');
      var filter = this.$('[data-rb-filter-toggle]');
      if (filter) filter.textContent = active.length ? 'Filtres · ' + active.map(e => e.childNodes[0].textContent.trim()).join(' · ') : 'Filtrer';
      var reset = this.$('.rb-mobile-reset'); if (reset) reset.hidden = !active.length;
    }

    mobileSummary() {
      var labels = { size: '1/4 · Taille', bed: '2/4 · Sommier', mattress: '3/4 · Matelas', ns: '4/4 · Chevets', review: 'Votre composition' };
      var summary = this.$('[data-rb-mobile-summary]');
      if (summary) summary.textContent = (labels[this.dataset.mobileStep] || labels.size) +
        (this.S.size ? ' · ' + this.S.size.replace('x', ' × ') + ' cm' : '');
      var mobile = window.matchMedia('(max-width:640px)').matches;
      if (mobile) this.$$('[data-rb-step]').forEach(button => { var active = button.dataset.rbGoto === 'rb-step-' + this.dataset.mobileStep; button.classList.toggle('is-on', active); if (active) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current'); });
      var dock = this.$('[data-rb-dock-cta]'); if (dock) { dock.textContent = mobile && this.dataset.mobileStep === 'review' ? 'Ajouter au panier' : 'Voir ma chambre'; dock.disabled = !!this.cartBusy; }
      this.$$('[data-rb-step]').forEach(button => {
        button.disabled = (!this.S.size && button.dataset.rbGoto !== 'rb-step-size') || (!this.S.bed && /mattress|ns$/.test(button.dataset.rbGoto || ''));
      });
    }

    track(action, detail) {
      this.dispatchEvent(new CustomEvent('casafab:configurator', {
        bubbles: true, detail: Object.assign({action:action, size:this.S.size || null}, detail || {})
      }));
    }

    restartRoom() {
      this.sizeRequest = (this.sizeRequest || 0) + 1;
      this.cancelStepMotion();
      this.savedRoom = null;
      this.roomId = 'rb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      try { sessionStorage.removeItem(this.storageKey); } catch (_) {}
      this.S = {size:null,bed:null,bedColor:0,mattress:null,skipM:false,ns:null,nsQty:1,skipNs:false,nsChoice:'auto',
        fStore:'all',fMat:'all',fAva:'all',colors:{},photos:{}};
      this.dataset.mobileStep = 'size';
      this.mobileLimit = 6;
      this.$$('[data-rb-size]').forEach(el => {el.classList.remove('is-on');el.setAttribute('aria-pressed','false');});
      this.nss.forEach(n => { n.el.dataset.rbCardQty = '1'; });
      this.resetChips();
      this.beds.forEach(b => this.paintBed(b)); this.paintMats(); this.applyFilters(); this.update();
      var alert = this.$('[data-rb-size-alert]'); if (alert) alert.hidden = true;
      this.track('restart'); this.say('Composition réinitialisée. Choisissez votre taille.');
      this.go(this.$('#rb-step-size'));
    }

    isCardSelectionTarget(target) {
      if (target.closest('[data-rb-select], [data-rb-select-mark]')) return true;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return false;
      if (Date.now() < (this.cardGestureUntil || 0) || window.getSelection()?.toString()) return false;
      return !target.closest('button, a, input, select, textarea, label, video, details, summary, [role="button"], [data-rb-stop], [data-rb-reviews], [data-rb-details]');
    }

    nightstandVariant(n, quantity) {
      if (!n) return null;
      var v = n.variant;
      if (v.tracked && Number(v.inventory) < quantity) {
        return Object.assign({}, v, {available: !!v.continueSelling && v.available, late:true,
          stock: v.continueSelling ? (v.arrival || 'Délai à confirmer pour cette quantité') : 'Quantité indisponible'});
      }
      return v;
    }

    saveRoom() {
      if (this.savedRoom || this.restoringRoom) return;
      var S = this.S;
      try { sessionStorage.setItem(this.storageKey, JSON.stringify({
        selectionVersion: 2, size: S.size, bed: S.bed && S.bed.id, color: S.bed && this.col(S.bed).name,
        mattress: S.mattress && S.mattress.id, skipM: S.skipM,
        ns: S.ns && S.ns.id, nsQty: S.nsQty, skipNs: S.skipNs, nsChoice: S.nsChoice, step: this.dataset.mobileStep
      })); } catch (_) {}
    }

    restoreRoom(finalAttempt) {
      var saved = this.savedRoom;
      if (!saved || !saved.size) { this.savedRoom = null; return; }
      if (!this.$$('[data-rb-size]').some(e => e.dataset.rbSize === saved.size)) { this.savedRoom = null; return; }
      var bed = this.beds.find(b => String(b.id) === String(saved.bed));
      if (saved.bed && !bed && !finalAttempt) return;
      if (saved.selectionVersion !== 2) {
        saved.mattress = null; saved.ns = null; saved.skipM = false; saved.skipNs = false;
        saved.nsQty = 1; saved.step = bed ? 'mattress' : 'bed';
      }
      this.restoringRoom = true;
      this.setSize(saved.size);
      if (bed) {
        var color = bed.colors.findIndex(c => c.name === saved.color && c.variants[saved.size] && c.variants[saved.size].available);
        if (color >= 0) { this.S.bed = bed; this.S.colors[bed.id] = color; this.S.bedColor = color; }
      }
      this.S.mattress = this.mats.find(m => String(m.id) === String(saved.mattress) && this.variant(m, saved.size)?.available) || null;
      this.S.skipM = !!saved.skipM;
      this.S.ns = this.nss.find(n => (String(n.id) === String(saved.ns) || String(n.productId) === String(saved.ns)) && n.variant.available) || null;
      this.S.nsQty = saved.nsQty === 2 ? 2 : 1;
      this.S.skipNs = !!saved.skipNs;
      this.S.nsChoice = saved.nsChoice === 'auto' ? 'auto' : (saved.ns || saved.skipNs ? 'manual' : 'auto');
      var stage = ['size','bed','mattress','ns','review'].includes(saved.step) ? saved.step : 'bed';
      this.dataset.mobileStep = !this.S.bed && ['mattress','ns','review'].includes(stage) ? 'bed' : stage;
      this.beds.forEach(b => this.paintBed(b)); this.paintMats(); this.paintNs(); this.applyFilters();
      this.savedRoom = null; this.restoringRoom = false; this.update();
    }

    /* ---------- lecture des données injectées par Liquid ---------- */
    readData() {
      var parse = (card) => {
        var tag = card.querySelector('[data-rb-json]');
        if (!tag) return null;
        try { var d = JSON.parse(tag.textContent); d.el = card; return d; }
        catch (e) { console.warn('[room-builder] JSON produit illisible', e); return null; }
      };
      this.beds = this.$$('[data-rb-bed]').map(parse).filter(Boolean);
      this.mats = this.$$('[data-rb-mattress]').map(parse).filter(Boolean);
      this.nss = this.$$('[data-rb-nightstand]').map(parse).filter(Boolean);
      this.linkReels();
    }

    /* ---------- vidéos ----------
       L'app embed ReelUp expose window.REELUP.videos sur TOUTES les pages :
       { id, title, short_video, thumbnail, full_video, products:[{id,handle}] }.
       Les fichiers sont hébergés sur le CDN Shopify, on les lit donc en direct
       avec une balise <video> native — pas de dépendance au lecteur de l'app. */
    reelCatalogue() {
      var byId = {}, byProduct = {};
      var list = (window.REELUP && window.REELUP.videos) || [];
      if (!Array.isArray(list)) list = [];
      list.forEach(function (v) {
        if (!v || !(v.full_video || v.short_video)) return;
        var src = v.full_video || v.short_video;
        src = src.replace('/%3Fv%3D', '?v=');
        var item = { id: v.id, src: src, fallback: v.short_video, poster: v.thumbnail || null, title: v.title || '' };
        byId[String(v.id)] = item;
        (v.products || []).forEach(function (p) {
          if (!p || p.id == null) return;
          (byProduct[String(p.id)] = byProduct[String(p.id)] || []).push(item);
        });
      });
      return { byId: byId, byProduct: byProduct, size: list.length };
    }

    linkReels() {
      var cat = this.reelCatalogue();
      this.beds.forEach(function (b) {
        var candidates = [];
        (b.reels || []).forEach(function (id) { if (cat.byId[String(id)]) candidates.push(cat.byId[String(id)]); });
        candidates = candidates.concat(cat.byProduct[String(b.id)] || [], b.nativeClips || []);
        var seen = new Set();
        var found = candidates.filter(function (clip) {
          if (!clip || !clip.src || seen.has(clip.src)) return false;
          seen.add(clip.src); return true;
        });
        b.clips = found;
        var signature = JSON.stringify(found);
        if (b.clipSignature === signature) return;
        b.clipSignature = signature;
        var slot = b.el.querySelector('[data-rb-video-slot]');
        if (!slot) return;
        slot.replaceChildren();
        if (!found.length) return;
        var button = document.createElement('button');
        button.type = 'button'; button.className = 'rb-video-feature';
        button.setAttribute('data-rb-reel', '');
        button.setAttribute('aria-label', 'Voir ' + b.title + ' en vidéo' + (found.length > 1 ? ' · ' + found.length + ' vidéos' : ''));
        var visual = document.createElement('span'); visual.className = 'rb-video-feature__visual';
        if (found[0].poster) {
          var image = document.createElement('img'); image.src = found[0].poster; image.alt = '';
          image.width = 54; image.height = 68; image.loading = 'lazy'; visual.appendChild(image);
        }
        var play = document.createElement('span'); play.textContent = '▶'; play.setAttribute('aria-hidden', 'true');
        visual.appendChild(play); button.appendChild(visual);
        var text = document.createElement('span'); text.className = 'rb-video-feature__copy';
        var title = document.createElement('strong'); title.textContent = 'Voir en vidéo';
        var subtitle = document.createElement('small');
        subtitle.textContent = found.length > 1 ? found.length + ' vidéos · Découvrez les détails' : 'Découvrez les détails en situation';
        text.append(title, subtitle); button.appendChild(text);
        var arrow = document.createElement('span'); arrow.className = 'rb-video-feature__arrow'; arrow.textContent = '→'; arrow.setAttribute('aria-hidden', 'true');
        button.appendChild(arrow); slot.appendChild(button);
      });
    }

    clipsOf(b) { return (b && b.clips) || []; }

    /* ---------- helpers ---------- */
    fmt(cents) { return this.money.format((cents || 0) / 100); }
    esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    colorForSize(color) {
      var variant = color && color.variants && color.variants[this.S.size];
      if (variant && variant.imgs && variant.imgs.length) {
        return Object.assign({}, color, { imgs: variant.imgs, img: variant.imgs[0] });
      }
      return color;
    }
    col(b) { return this.colorForSize(b.colors[Math.min(this.S.colors[b.id] || 0, b.colors.length - 1)]); }
    photoIdx(b) { var c = this.col(b); return Math.min(this.S.photos[b.id] || 0, c.imgs.length - 1); }
    bedImg(b) { var c = this.col(b); return c.imgs[this.photoIdx(b)] || c.img; }
    /** variante d'un produit pour la taille courante */
    variant(p, size) { return (p && p.variants && p.variants[size]) || null; }
    bedVariant(b) { var c = this.col(b); return (c.variants && c.variants[this.S.size]) || null; }
    colorAvailable(color) {
      if (!color) return false;
      if (!this.S.size) return true;
      var variant = color.variants && color.variants[this.S.size];
      return !!(variant && variant.available);
    }
    sizesOf(b) { var out = {}; b.colors.forEach(c => Object.keys(c.variants || {}).forEach(s => { if (c.variants[s].available) out[s] = 1; })); return Object.keys(out); }
    say(msg) { var l = this.$('[data-rb-live]'); if (l) l.textContent = msg; }
    cancelStepMotion() {
      clearTimeout(this.stepDelay);
      cancelAnimationFrame(this.stepFrame);
      if (this.stepEvents) this.stepEvents.abort();
    }

    go(el, advance) {
      if (this.mobileDetail) this.closeMobileDetail(false);
      this.cancelStepMotion();
      if (!el) return;
      var stage = el.matches('[data-rb-panel]') ? 'review' : (el.id || '').replace('rb-step-', '');
      if (stage) { this.track('step', {step:stage}); this.dataset.mobileStep = stage; this.mobileSummary(); this.saveRoom(); }
      if (!el.getClientRects().length) return;
      this.stepEvents = new AbortController();
      var signal = this.stepEvents.signal;
      var cancel = () => this.cancelStepMotion();
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
        document.addEventListener(type, cancel, { signal: signal, passive: true });
      });
      this.stepDelay = setTimeout(() => {
        if (!this.isConnected || !el.getClientRects().length) { cancel(); return; }
        var title = el.querySelector('h2') || el;
        var nav = this.$('.rb-steps');
        var offset = (nav ? nav.getBoundingClientRect().height : 0) + 24;
        if (document.querySelector('.rb-simple-header')) offset += parseFloat(getComputedStyle(document.body).getPropertyValue('--rb-follow-height')) || 60;
        var start = window.scrollY;
        var panelVisible = el.matches('[data-rb-panel]') && el.getBoundingClientRect().top >= 0 && el.getBoundingClientRect().top < window.innerHeight / 2;
        var target = panelVisible ? start : Math.max(0, Math.min(
          window.scrollY + el.getBoundingClientRect().top - offset,
          document.documentElement.scrollHeight - window.innerHeight
        ));
        var finish = () => {
          cancel();
          title.setAttribute('tabindex', '-1');
          title.focus({ preventScroll: true });
          if (!RM.matches && title.animate) {
            title.animate([
              { backgroundColor: 'rgba(128,60,238,.12)', boxShadow: '0 0 0 8px rgba(128,60,238,.12)' },
              { backgroundColor: 'transparent', boxShadow: '0 0 0 8px transparent' }
            ], { duration: 750, easing: 'ease-out' });
          }
        };
        if (RM.matches) { window.scrollTo({ top: target, behavior: 'instant' }); finish(); return; }
        var began = performance.now();
        var frame = now => {
          var progress = Math.min(1, (now - began) / 480);
          var eased = 1 - Math.pow(1 - progress, 3);
          window.scrollTo({ top: start + (target - start) * eased, behavior: 'instant' });
          if (progress < 1) this.stepFrame = requestAnimationFrame(frame);
          else finish();
        };
        this.stepFrame = requestAnimationFrame(frame);
      }, advance && !RM.matches ? 120 : 0);
    }
    stars(r) { var n = Math.round(r || 0); return '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n); }


    /* Le catalogue suit les pages Shopify, sans liste d'identifiants figée. */
    async loadMoreBeds() {
      if (this.loadingBeds) return;
      var next = this.$('[data-rb-catalog-next]');
      if (!next) return;
      this.loadingBeds = true;
      var status = this.$('[data-rb-catalog-status]');
      var seen = new Set(), pendingBeds = [];
      var existing = new Set(this.beds.map(b => String(b.id)));
      try {
        while (next && next.dataset.rbCatalogNext) {
          var url = new URL(next.dataset.rbCatalogNext, location.href);
          if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Pagination invalide');
          seen.add(url.href);
          url.searchParams.set('section_id', 'casafab-room-catalog');
          if (status) { status.hidden = false; status.textContent = 'Chargement des autres lits…'; }
          var response = await fetch(url.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalogue indisponible');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var root = doc.querySelector('casafab-room-builder');
          if (!root) throw new Error('Catalogue incomplet');
          var grid = this.$('[data-rb-bed-grid]');
          var added = [];
          root.querySelectorAll('[data-rb-bed]').forEach(function (card) {
            var tag = card.querySelector('[data-rb-json]');
            if (!tag) throw new Error('Produit incomplet');
            var data = JSON.parse(tag.textContent);
            if (existing.has(String(data.id))) return;
            existing.add(String(data.id));
            data.el = document.importNode(card, true);
            added.push(data);
          });
          pendingBeds.push.apply(pendingBeds, added);
          var remoteNext = root.querySelector('[data-rb-catalog-next]');
          next.dataset.rbCatalogNext = remoteNext ? remoteNext.dataset.rbCatalogNext : '';

        }
        if (status) { status.hidden = true; status.textContent = ''; }
      } catch (error) {
        if (status) {
          status.hidden = false;
          status.textContent = 'Certains lits restent à charger. ';
          var retry = document.createElement('button');
          retry.type = 'button'; retry.textContent = 'Réessayer';
          retry.setAttribute('data-rb-catalog-retry', '');
          status.appendChild(retry);
        }
        console.warn('[room-builder] chargement du catalogue incomplet', error);
      } finally {
        if (pendingBeds.length && this.isConnected) {
          var fragment = document.createDocumentFragment();
          pendingBeds.forEach(bed => fragment.appendChild(bed.el));
          this.$('[data-rb-bed-grid]').appendChild(fragment);
          this.beds.push.apply(this.beds, pendingBeds);
          this.linkReels();
          pendingBeds.forEach(bed => this.paintBed(bed));
          this.refreshBedSizes();
          if (this.S.size) this.applyFilters();
        }
        this.loadingBeds = false; this.restoreRoom(true);
      }
    }

    refreshBedSizes() {
      this.$$('[data-rb-size]').forEach(button => {
        var size = button.dataset.rbSize;
        var beds = this.beds.filter(b => this.sizesOf(b).includes(size));
        var prices = [];
        beds.forEach(b => b.colors.forEach(c => {
          var v = c.variants[size];
          if (v && v.available) prices.push(v.price);
        }));
        var mattresses = this.mats.filter(m => this.variant(m, size));
        button.hidden = !beds.length;
        var label = button.querySelector('em');
        if (label) label.textContent = beds.length + ' sommiers' +
          (prices.length ? ' · dès ' + this.fmt(Math.min.apply(null, prices)) : '');
      });
    }


    /* Compact mobile catalog. The original card becomes the detail sheet: no
       duplicate product state, IDs, review widgets or selection handlers. */
    setupCompactMobile() {
      this.compactEvents = new AbortController();
      window.addEventListener('resize', () => {
        if (!window.matchMedia('(max-width:640px)').matches) this.closeMobileDetail(false);
        this.beds.forEach(b => this.prepareCompactCard(b.el, this.bedVariant(b)));
      }, {signal:this.compactEvents.signal});
      this.classList.add('rb-compact-ready');
    }

    prepareCompactCard(card, variant) {
      var body = card.querySelector('.rb-card__body');
      if (!body) return;
      var opener = card.querySelector('[data-rb-compact-open]');
      if (!opener) {
        opener = document.createElement('button'); opener.type = 'button';
        opener.className = 'rb-compact-open'; opener.dataset.rbCompactOpen = '';
        opener.setAttribute('aria-haspopup','dialog'); opener.textContent = 'Voir les détails';
        body.appendChild(opener);
        var info = document.createElement('p'); info.className = 'rb-compact-info'; body.appendChild(info);
        var quick = document.createElement('button'); quick.type = 'button';
        quick.className = 'rb-compact-choose'; quick.dataset.rbCompactChoose = '';
        quick.addEventListener('click', e => { e.stopPropagation(); card.querySelector('[data-rb-select]').click(); });
        body.appendChild(quick);
      }
      var title = card.querySelector('h3').textContent.trim();
      opener.setAttribute('aria-label','Voir les détails de ' + title);
      var info = card.querySelector('.rb-compact-info');
      info.textContent = variant ? (!variant.available ? 'Indisponible' : variant.late ? (variant.stock || 'En arrivage') : 'En stock · Livraison rapide') : '';
      info.title = variant && variant.stock || '';
      info.classList.toggle('is-stock', !!(variant && variant.available && !variant.late));
      var quick = card.querySelector('.rb-compact-choose'), selected = card.classList.contains('is-sel');
      quick.disabled = !variant || !variant.available;
      quick.textContent = selected ? (card.matches('[data-rb-bed]') ? '✓ Choisi' : '✓ Choisi · Retirer') : 'Choisir';
      quick.setAttribute('aria-pressed',String(selected));
      quick.setAttribute('aria-label',(selected ? 'Sélection actuelle : ' : 'Choisir ') + title);
      var colors = Array.from(card.querySelectorAll('[data-rb-color]')).filter(x => !x.hidden);
      colors.forEach(x => {
        x.classList.remove('rb-compact-extra');
        var label=x.querySelector('.rb-fabric-name');
        if (!label) { label=document.createElement('span'); label.className='rb-fabric-name'; x.appendChild(label); }
        label.textContent=x.getAttribute('aria-label');
      });
      card.querySelector('.rb-compact-colors')?.remove();
      if (colors.length) {
        var fabricTitle=card.querySelector('.rb-fabric-title');
        if (!fabricTitle) {
          fabricTitle=document.createElement('button'); fabricTitle.type='button'; fabricTitle.className='rb-fabric-title';
          fabricTitle.dataset.rbCompactOpen=''; fabricTitle.setAttribute('aria-haspopup','dialog');
          card.querySelector('.rb-sw').before(fabricTitle);
          var current=document.createElement('p'); current.className='rb-fabric-current'; current.setAttribute('aria-live','polite');
          card.querySelector('.rb-sw').after(current);
        }
        fabricTitle.textContent='Couleurs & tissus ('+colors.length+') ›';
        fabricTitle.setAttribute('aria-label','Choisir la couleur et le tissu de '+title);
        card.querySelector('.rb-fabric-current').textContent=card.querySelector('[data-rb-color-name]')?.textContent || '';
      }
      var ratingCount = card.querySelector('.rb-rate>span:last-child');
      if (ratingCount) ratingCount.dataset.rbCompactCount = '(' + (ratingCount.textContent.match(/\d+/)?.[0] || '0') + ')';
      if (card.matches('[data-rb-mattress]') && !card.querySelector('.rb-compact-comfort')) {
        var comfort = document.createElement('p'); comfort.className='rb-compact-comfort';
        var guide = card.querySelector('.rb-mat-guide');
        var rows = guide ? Array.from(guide.querySelectorAll('dd')).map(x=>x.textContent.trim()) : [];
        comfort.textContent = rows.slice(0,2).join(' · ').replace('Ressorts ensachés et mémoire de forme', 'Mémoire de forme').replace('Ressorts ensachés et surmatelas intégré','Surmatelas intégré');
        if (!comfort.textContent && guide) comfort.textContent=guide.querySelector('p')?.textContent || '';
        body.insertBefore(comfort, body.querySelector('.rb-foot'));
      }
      if (this.mobileDetail === card) this.syncMobileDetail();
    }

    lockMobileBackground() {
      var node = this.mobileDetail;
      this.mobileInert = this.mobileInert || [];
      while (node && node !== this) {
        Array.from(node.parentElement.children).forEach(sibling => {
          if (sibling === node || sibling.matches('[data-rb-lb],.rb-detail-backdrop,.rb-detail-placeholder') || sibling.inert) return;
          sibling.inert=true; this.mobileInert.push(sibling);
        });
        node=node.parentElement;
      }
    }

    openMobileDetail(card, target) {
      if (this.mobileDetail) return;
      this.cancelStepMotion();
      this.mobileDetail=card; this.mobileOpener=target.closest('button,a') || card.querySelector('.rb-compact-open');
      this.mobileScroll=window.scrollY; this.mobileOverflow=document.body.style.overflow;
      var placeholder=document.createElement('div'); placeholder.className='rb-detail-placeholder';
      placeholder.style.height=card.getBoundingClientRect().height+'px'; placeholder.setAttribute('aria-hidden','true');
      card.before(placeholder); this.mobilePlaceholder=placeholder;
      var backdrop=document.createElement('button'); backdrop.type='button'; backdrop.className='rb-detail-backdrop';
      backdrop.dataset.rbDetailClose=''; backdrop.setAttribute('aria-label','Fermer les détails'); backdrop.tabIndex=-1;
      this.appendChild(backdrop); this.mobileBackdrop=backdrop;
      var header=document.createElement('div'); header.className='rb-detail-header';
      var label=document.createElement('strong'); label.textContent=card.querySelector('h3').textContent;
      var close=document.createElement('button'); close.type='button'; close.dataset.rbDetailClose=''; close.textContent='✕ Fermer'; close.setAttribute('aria-label','Fermer les détails et revenir aux modèles');
      header.append(label,close); card.prepend(header);
      var footer=document.createElement('div'); footer.className='rb-detail-footer';
      var price=document.createElement('strong');
      var choose=document.createElement('button'); choose.type='button'; choose.dataset.rbDetailChoose='';
      footer.append(price,choose); card.appendChild(footer);
      card.classList.add('is-mobile-detail'); card.setAttribute('role','dialog'); card.setAttribute('aria-modal','true'); card.setAttribute('aria-label',label.textContent);
      document.body.style.overflow='hidden'; this.classList.add('has-mobile-detail');
      this.lockMobileBackground(); this.syncMobileDetail(); card.scrollTop=0; close.focus({preventScroll:true});
      if (target.closest('.rb-fabric-title')) card.querySelector('.rb-sw')?.scrollIntoView({block:'center'});
    }

    syncMobileDetail() {
      var card=this.mobileDetail, footer=card && card.querySelector('.rb-detail-footer');
      if (!footer) return;
      var select=card.querySelector('[data-rb-select]');
      footer.querySelector('strong').textContent=card.querySelector('[data-rb-price]')?.textContent || '';
      var choose=footer.querySelector('button'); choose.disabled=select.disabled;
      choose.textContent=card.classList.contains('is-sel') ? 'Continuer avec ce modèle' : 'Choisir ce modèle';
    }

    closeMobileDetail(restoreFocus=true) {
      var card=this.mobileDetail; if (!card) return;
      if (this.$('[data-rb-lb]').classList.contains('is-open')) this.closeLb();
      card.classList.remove('is-mobile-detail');
      ['role','aria-modal','aria-label'].forEach(a=>card.removeAttribute(a));
      card.querySelector('.rb-detail-header')?.remove(); card.querySelector('.rb-detail-footer')?.remove();
      this.mobilePlaceholder?.remove(); this.mobileBackdrop?.remove();
      (this.mobileInert||[]).forEach(x=>x.inert=false); this.mobileInert=[];
      this.mobileDetail=null; this.classList.remove('has-mobile-detail');
      document.body.style.overflow=this.mobileOverflow || '';
      window.scrollTo({top:this.mobileScroll,behavior:'instant'});
      if (restoreFocus) this.mobileOpener?.focus({preventScroll:true});
    }

    /* ---------- écouteurs ---------- */
    bind() {
      var self = this;

      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest('[data-rb-detail-close]')) { self.closeMobileDetail(); return; }
        if (t.closest('[data-rb-detail-choose]')) {
          var detailCard = self.mobileDetail;
          if (!detailCard) return;
          var select = detailCard.querySelector('[data-rb-select]');
          if (!select || select.disabled) return;
          var already = detailCard.classList.contains('is-sel');
          self.closeMobileDetail(false);
          if (already) self.go(self.$(detailCard.matches('[data-rb-bed]') ? '#rb-step-mattress' : detailCard.matches('[data-rb-mattress]') ? '#rb-step-ns' : '[data-rb-panel]'), true);
          else select.click();
          return;
        }
        var compactCard = t.closest('.rb-card');
        if (compactCard && window.matchMedia('(max-width:640px)').matches && !self.mobileDetail) {
          if (t.closest('[data-rb-compact-open], .rb-card__vis, .rb-card__t h3')) {
            if (Date.now() < (self.swipeUntil || 0) || Date.now() < (self.cardGestureUntil || 0)) return;
            e.preventDefault(); self.openMobileDetail(compactCard, t); return;
          }
        }

        if (Date.now() < (self.swipeUntil || 0) && t.closest('[data-rb-bed] .rb-card__vis')) return;
        if (t.closest('[data-rb-filter-apply]')) { self.classList.remove('filters-open'); self.$('[data-rb-filter-toggle]').setAttribute('aria-expanded', 'false'); self.go(self.$('#rb-step-bed')); return; }
        if (t.closest('[data-rb-more]')) { self.mobileLimit += 6; self.limitMobileBeds(); return; }
        if (t.closest('[data-rb-filter-toggle]')) {
          var toggle = self.$('[data-rb-filter-toggle]');
          var open = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', String(open)); self.classList.toggle('filters-open', open); return;
        }
        if (t.closest('[data-rb-restart]')) { self.restartRoom(); return; }
        if (t.closest('[data-rb-skip-ns]')) { self.remove('nightstand'); return; }
        if (t.closest('[data-rb-without-ns]')) { self.S.nsChoice = 'manual'; self.S.skipNs = true; self.S.ns = null; self.S.nsQty = 1; self.paintNs(); self.update(); self.go(self.$('[data-rb-panel]'), true); return; }

        /* taille */
        var sz = t.closest('[data-rb-size]');
        if (sz) { self.chooseSize(sz.dataset.rbSize); return; }
        if (t.closest('[data-rb-size-change]')) { self.go(self.$('#rb-step-size')); return; }

        /* filtres */
        var f = t.closest('[data-rb-filter]');
        if (f) {
          self.mobileLimit = 6;
          var group = f.dataset.rbGroup;
          self.S[group] = f.dataset.rbFilter;
          f.parentNode.querySelectorAll('[data-rb-filter]').forEach(function (x) {
            var on = x === f; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on);
          });
          self.applyFilters();
          return;
        }
        if (t.closest('[data-rb-reset]')) { self.S.fStore = self.S.fMat = self.S.fAva = 'all'; self.resetChips(); self.applyFilters(); return; }

        /* navigation interne */
        var g = t.closest('[data-rb-goto]');
        if (g) { self.go(self.$('#' + (self.S.size ? g.dataset.rbGoto : 'rb-step-size'))); return; }

        /* retirer depuis le panneau */
        var del = t.closest('[data-rb-del]');
        if (del) { self.remove(del.dataset.rbDel); return; }

        /* lien fiche produit : on laisse passer */
        if (t.closest('a[data-rb-stop]')) return;

        if (t.closest('[data-rb-title-gallery]')) { self.openLb(self.beds.find(b => b.el === t.closest('[data-rb-bed]'))); return; }
        /* galerie */
        var reel = t.closest('[data-rb-reel]');
        if (reel) { self.openLb(self.beds.find(b => b.el === reel.closest('[data-rb-bed]')), true); return; }
        var zoom = t.closest('[data-rb-zoom]');
        if (zoom) { self.openLb(self.beds.find(b => b.el === zoom.closest('[data-rb-bed]'))); return; }

        if (t.closest('[data-rb-catalog-retry]')) { self.loadMoreBeds(); return; }
        /* Les interactions Loox ne sélectionnent jamais le produit. */
        if (t.closest('[data-rb-reviews]')) return;
        if (t.closest('[data-rb-details] summary')) return;

        /* sommier */
        var bedCard = t.closest('[data-rb-bed]');
        if (bedCard) {
          var bed = self.beds.find(b => b.el === bedCard);
          var arrow = t.closest('[data-rb-gallery-step]');
          if (arrow) {
            var photos = self.col(bed).imgs;
            if (photos.length < 2) return;
            self.S.photos[bed.id] = (self.photoIdx(bed) + Number(arrow.dataset.rbGalleryStep) + photos.length) % photos.length;
            self.paintBed(bed);
            if (self.S.bed === bed) self.update();
            return;
          }
          if (t.matches('[data-rb-main]')) { self.openLb(bed); return; }
          var sw = t.closest('[data-rb-color]');
          if (sw) {
            if (!self.colorAvailable(bed.colors[Number(sw.dataset.rbColor)])) return;
            self.S.colors[bed.id] = Number(sw.dataset.rbColor); self.S.photos[bed.id] = 0;
            self.paintBed(bed);
            self.applyFilters();
            if (self.S.bed === bed) { self.update(); self.pop('[data-rb-line="bed"]'); self.say('Coloris ' + self.col(bed).name + ' retenu.'); }
            return;
          }
          var ph = t.closest('[data-rb-photo]');
          if (ph) { self.S.photos[bed.id] = Number(ph.dataset.rbPhoto); self.paintBed(bed); if (self.S.bed === bed) self.update(); return; }
          if (t.closest('[data-rb-details], [data-rb-stop], a, input, select, textarea, video, summary')) return;
          if (!self.isCardSelectionTarget(t)) return;
          if (Date.now() < (self.cardGestureUntil || 0)) return;
          var was = self.S.bed === bed;
          if (was) return;
          var chosenVariant = self.bedVariant(bed);
          if (!chosenVariant || !chosenVariant.available) return;
          self.S.bed = bed;
          if (self.S.bed) self.S.bedColor = self.S.colors[bed.id] || 0;
          self.beds.forEach(b => self.paintBed(b));
          self.applyFilters(); self.update(); self.pop('[data-rb-line="bed"]');
          self.say(was ? 'Sommier ' + bed.title + ' retiré.' : 'Sommier ' + bed.title + ' ajouté.');
          if (!was) self.go(self.$('#rb-step-mattress'), true);
          return;
        }

        /* matelas */
        var matCard = t.closest('[data-rb-mattress]');
        if (matCard) {
          if (!self.isCardSelectionTarget(t)) return;
          var m = self.mats.find(x => x.el === matCard);
          if (!m || !self.variant(m, self.S.size)?.available) return;
          var wasM = self.S.mattress === m;
          self.S.mattress = wasM ? null : m;
          if (self.S.mattress) self.S.skipM = false;
          self.paintMats(); self.update(); self.pop('[data-rb-line="mattress"]');
          self.say(wasM ? 'Matelas ' + m.title + ' retiré.' : 'Matelas ' + m.title + ' ajouté.');
          if (!wasM) self.go(self.$('#rb-step-ns'), true);
          return;
        }
        if (t.closest('[data-rb-skip-mattress]')) {
          self.S.skipM = true; self.S.mattress = null;
          self.paintMats(); self.update();
          self.say(self.S.skipM ? 'Étape matelas passée.' : 'Étape matelas réactivée.');
          if (self.S.skipM) self.go(self.$('#rb-step-ns'), true);
          return;
        }

        /* chevets */
        var nsCard = t.closest('[data-rb-nightstand]');
        if (nsCard) {
          var n = self.nss.find(x => x.el === nsCard);
          var q = t.closest('[data-rb-qty]');
          if (q) {
            if (!self.nightstandVariant(n, Number(q.dataset.rbQty))?.available) return;
            nsCard.dataset.rbCardQty = q.dataset.rbQty;
            if (self.S.ns === n) self.S.nsQty = Number(q.dataset.rbQty);
            self.paintNs(); self.update(); return;
          }
          if (!self.isCardSelectionTarget(t)) return;
          var wasN = self.S.ns === n;
          if (!self.nightstandVariant(n, Number(nsCard.dataset.rbCardQty || 1))?.available) return;
          self.S.nsChoice = 'manual';
          if (wasN) { self.S.ns = null; self.S.nsQty = 1; }
          else { self.S.skipNs = false; self.S.ns = n; self.S.nsQty = Number(nsCard.dataset.rbCardQty || 1); }
          self.paintNs(); self.update(); self.pop('[data-rb-line="nightstand"]');
          self.say(wasN ? 'Chevet retiré.' : self.S.nsQty + ' chevet' + (self.S.nsQty > 1 ? 's' : '') + ' ' + n.title + ' ajouté.');
          if (!wasN) self.go(self.$('[data-rb-panel]'), true);
          return;
        }

        /* panier */
        if (t.closest('[data-rb-another-room]')) { self.addToCart(true); return; }
        if (t.closest('[data-rb-add]')) { self.addToCart(); return; }
        if (t.closest('[data-rb-dock-cta]')) { if (self.dataset.mobileStep === 'review' && window.matchMedia('(max-width:640px)').matches) self.addToCart(); else self.go(self.$('[data-rb-panel]')); return; }

        /* galerie : contrôles */
        if (t.closest('[data-rb-lb-close]') || t === self.$('[data-rb-lb]') || t === self.$('.rb-lb__stage')) { self.closeLb(); return; }
        if (t.closest('[data-rb-lb-prev]')) { self.LB.i--; self.paintLb(); return; }
        if (t.closest('[data-rb-lb-next]')) { self.LB.i++; self.paintLb(); return; }
        var lbt = t.closest('[data-rb-lb-thumb]');
        if (lbt) { self.LB.i = Number(lbt.dataset.rbLbThumb); self.paintLb(); return; }
      });

      this.onKey = function (e) {
        if (self.mobileDetail && !self.$('[data-rb-lb]').classList.contains('is-open')) {
          if (e.key === 'Escape') { e.preventDefault(); self.closeMobileDetail(); return; }
          if (e.key === 'Tab') {
            var controls = Array.from(self.mobileDetail.querySelectorAll('button:not(:disabled),a[href],summary,[tabindex="0"]')).filter(x => x.getClientRects().length && !x.closest('[hidden]'));
            var first = controls[0], last = controls[controls.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          }
          return;
        }

        if (!self.$('[data-rb-lb]').classList.contains('is-open')) return;
        if (e.key === 'Escape') { self.closeLb(); return; }
        if (e.key === 'ArrowLeft') { self.LB.i--; self.paintLb(); return; }
        if (e.key === 'ArrowRight') { self.LB.i++; self.paintLb(); return; }
        if (e.key === 'Tab') {
          var f = self.lbFocusables(); if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };
      document.addEventListener('keydown', this.onKey);
    }

    pop(sel) { var el = this.$(sel); if (!el) return; el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }

    resetChips() {
      this.$$('[data-rb-filter]').forEach(x => {
        var on = x.dataset.rbFilter === 'all';
        x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on);
      });
    }

    remove(kind) {
      if (kind === 'bed') { this.S.bed = null; this.beds.forEach(b => this.paintBed(b)); this.applyFilters(); this.say('Sommier retiré.'); }
      if (kind === 'mattress') { this.S.mattress = null; this.paintMats(); this.say('Matelas retiré.'); }
      if (kind === 'nightstand') { this.S.nsChoice = 'manual'; this.S.ns = null; this.S.nsQty = 1; this.paintNs(); this.say('Chevet retiré.'); }
      this.update();
      if (kind === 'bed' && window.matchMedia('(max-width:640px)').matches) this.go(this.$('#rb-step-bed'));
    }

    /* ---------- taille, avec invalidation en cascade ---------- */
    async chooseSize(size) {
      var request = this.sizeRequest = (this.sizeRequest || 0) + 1;
      this.cancelStepMotion();
      this.$$('[data-rb-size]').forEach(button => {
        var pending = button.dataset.rbSize === size;
        button.classList.toggle('is-loading', pending);
        button.setAttribute('aria-busy', String(pending));
      });
      this.say('Préparation des sommiers en ' + size + '…');
      var wait;
      try {
        await Promise.race([
          Promise.allSettled([this.catalogReady, this.rankingReady]),
          new Promise(resolve => { wait = setTimeout(resolve, 1200); })
        ]);
        if (request !== this.sizeRequest || !this.isConnected) return;
        this.setSize(size);
        var grid = this.$('[data-rb-bed-grid]');
        Array.from(grid.querySelectorAll('[data-rb-bed]')).filter(card => !card.hidden).slice(0, 3).forEach(card => {
          var image = card.querySelector('[data-rb-main]');
          if (image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
        });
        requestAnimationFrame(() => {
          if (request === this.sizeRequest && this.isConnected) this.go(this.$('#rb-step-bed'), true);
        });
      } finally {
        clearTimeout(wait);
        if (request === this.sizeRequest) this.$$('[data-rb-size]').forEach(button => {
          button.classList.remove('is-loading'); button.removeAttribute('aria-busy');
        });
      }
    }

    setSize(size) {
      if (this.S.size === size) return;
      var lost = [];
      if (this.S.bed && this.sizesOf(this.S.bed).indexOf(size) === -1) { lost.push('le sommier ' + this.S.bed.title); this.S.bed = null; }
      if (this.S.mattress && !this.variant(this.S.mattress, size)) { lost.push('le matelas ' + this.S.mattress.title); this.S.mattress = null; }
      this.mobileLimit = 6;
      this.S.size = size;
      this.S.photos = {};
      this.S.fStore = this.S.fMat = this.S.fAva = 'all';
      this.$$('[data-rb-size]').forEach(b => {
        var on = b.dataset.rbSize === size;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
      this.resetChips();
      this.beds.forEach(b => this.paintBed(b));
      this.paintMats();
      this.applyFilters();
      this.update();
      var alert = this.$('[data-rb-size-alert]');
      if (lost.length) {
        var txt = lost.join(' et ');
        alert.innerHTML = '— <b>' + this.esc(txt.charAt(0).toUpperCase() + txt.slice(1)) + '</b> n’existe pas dans cette taille et a été retiré.';
        alert.hidden = false;
        clearTimeout(this.alertT);
        this.alertT = setTimeout(function () { alert.hidden = true; }, 7000);
        this.say('Taille ' + size + ' retenue. ' + txt + ' a été retiré.');
      } else {
        alert.hidden = true;
        this.say('Taille ' + size + ' retenue.');
      }
    }

    matsOf(b) { return (b.mats && b.mats.length) ? b.mats : (b.mat ? [b.mat] : []); }

    /* ---------- filtres ---------- */
    async loadSalesRanking() {
      var marker = this.$('[data-rb-sales-url]');
      if (!marker) return;
      var next = marker.dataset.rbSalesUrl, seen = new Set(), ranks = new Map();
      try {
        while (next && this.isConnected) {
          var url = new URL(next, location.href);
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.set('section_id', 'casafab-room-sales-ranking');
          if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Pagination des ventes invalide');
          seen.add(url.href);
          var response = await fetch(url.href, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Classement indisponible');
          var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          var data = doc.querySelector('[data-rb-sales-ranking]');
          if (!data) throw new Error('Classement incomplet');
          var page = JSON.parse(data.textContent);
          page.ids.forEach(id => { if (!ranks.has(String(id))) ranks.set(String(id), ranks.size); });
          next = page.next;
        }
        this.salesRanks = ranks;
        this.sortBedsByStock(); this.limitMobileBeds();
      } catch (error) { console.warn('[room-builder] classement des ventes indisponible', error); }
    }

    inStockColorIndex(bed) {
      return bed.colors.findIndex(color => {
        var variant = color.variants && color.variants[this.S.size];
        return !!(variant && variant.available && !variant.late);
      });
    }

    sortBedsByStock() {
      var grid = this.$('[data-rb-bed-grid]');
      if (!grid || !this.S.size || this.mobileDetail) return;
      var ranked = this.beds.map((bed, index) => {
        var inStock = this.inStockColorIndex(bed) !== -1;
        var salesRank = this.salesRanks && this.salesRanks.get(String(bed.id));
        return { bed: bed, index: index, salesRank: salesRank === undefined ? Number.MAX_SAFE_INTEGER : salesRank, rank: inStock ? 0 : 1 };
      }).sort((a, b) => a.rank - b.rank || (a.rank === 0 ? a.salesRank - b.salesRank : 0) || a.index - b.index);
      var current = Array.from(grid.children).filter(el => el.matches('[data-rb-bed]'));
      ranked.forEach((item, index) => {
        if (current[index] === item.bed.el) return;
        var reference = current[index] || null;
        if (typeof grid.moveBefore === 'function') grid.moveBefore(item.bed.el, reference);
        else grid.insertBefore(item.bed.el, reference);
        var previous = current.indexOf(item.bed.el);
        if (previous !== -1) current.splice(previous, 1);
        current.splice(index, 0, item.bed.el);
      });
    }

    applyFilters() {
      var S = this.S, shown = 0, self = this;
      var pool = this.beds.filter(b => self.sizesOf(b).indexOf(S.size) !== -1);
      pool.forEach(function (b) {
        var v = self.bedVariant(b) || {};
        var okS = S.fStore === 'all' || (S.fStore === 'coffre' ? b.coffre : !b.coffre);
        var okM = S.fMat === 'all' || self.matsOf(b).indexOf(S.fMat) !== -1;
        var av = self.inStockColorIndex(b) !== -1 ? 'stock' : 'arrivage';
        var okA = S.fAva === 'all' || av === S.fAva;
        var vis = (okS && okM && okA) || S.bed === b;
        b.el.hidden = !vis; if (vis) shown++;
      });
      /* hors taille : toujours masqué */
      this.beds.filter(b => pool.indexOf(b) === -1).forEach(b => { b.el.hidden = true; });

      /* compteurs des puces */
      this.$$('[data-rb-filter]').forEach(function (chip) {
        var g = chip.dataset.rbGroup, k = chip.dataset.rbFilter, n;
        if (k === 'all') n = pool.length;
        else if (g === 'fStore') n = pool.filter(b => k === 'coffre' ? b.coffre : !b.coffre).length;
        else if (g === 'fMat') n = pool.filter(b => self.matsOf(b).indexOf(k) !== -1).length;
        else n = pool.filter(b => (self.inStockColorIndex(b) !== -1 ? 'stock' : 'arrivage') === k).length;
        var u = chip.querySelector('u'); if (u) u.textContent = n;
        chip.hidden = (n === 0 && k !== 'all');
      });

      /* un groupe qui ne trie rien (0 ou 1 puce utile couvrant tout) est masque */
      this.$$('.rb-fgroup').forEach(function (g) {
        var live = Array.prototype.slice.call(g.querySelectorAll('[data-rb-filter]'))
          .filter(c => !c.hidden && c.dataset.rbFilter !== 'all');
        var covers = live.length === 1 && Number((live[0].querySelector('u') || {}).textContent || 0) >= pool.length;
        g.hidden = pool.length === 0 || live.length === 0 || covers;
      });

      var total = pool.length, nc = pool.filter(b => b.coffre).length;
      var filtered = S.fStore !== 'all' || S.fMat !== 'all' || S.fAva !== 'all';
      var cnt = this.$('[data-rb-bed-count]');
      if (cnt) cnt.textContent = !S.size ? ''
        : filtered ? shown + ' sommier' + (shown > 1 ? 's' : '') + ' sur ' + total + ' en ' + S.size
        : total + ' sommier' + (total > 1 ? 's' : '') + ' en ' + S.size + (nc ? ', dont ' + nc + ' avec coffre de rangement' : '');
      var empty = this.$('[data-rb-empty]');
      if (empty) empty.hidden = shown > 0;
      var grid = this.$('[data-rb-bed-grid]');
      if (grid) grid.classList.toggle('has-sel', !!S.bed);
      this.sortBedsByStock();

      this.limitMobileBeds();
      /* matelas : ne montrer que ceux disponibles dans la taille */
      this.mats.forEach(m => { m.el.hidden = !this.variant(m, S.size); });
    }

    /* ---------- peinture des cartes (mutation ciblée) ---------- */
    paintBed(b) {
      var heading = b.el.querySelector('h3');
      if (heading && !heading.querySelector('[data-rb-title-gallery]')) {
        var title = document.createElement('button');
        title.type = 'button'; title.className = 'rb-title-gallery';
        title.setAttribute('data-rb-title-gallery', '');
        title.setAttribute('aria-label', 'Voir les photos de ' + b.title);
        title.setAttribute('aria-haspopup', 'dialog');
        title.textContent = heading.textContent; heading.replaceChildren(title);
      }
      if (this.S.size && b.defaultColorSize !== this.S.size) {
        b.defaultColorSize = this.S.size;
        var inStockIndex = this.inStockColorIndex(b);
        if (inStockIndex !== -1 && this.S.bed !== b) {
          this.S.colors[b.id] = inStockIndex;
          this.S.photos[b.id] = 0;
        }
      }
      if (this.S.size && !this.colorAvailable(this.col(b))) {
        var compatible = b.colors.findIndex(color => this.colorAvailable(color));
        if (compatible !== -1) {
          this.S.colors[b.id] = compatible;
          this.S.photos[b.id] = 0;
          if (this.S.bed === b) this.S.bedColor = compatible;
        }
      }
      var c = this.col(b), k = this.photoIdx(b), on = this.S.bed === b, el = b.el;
      el.style.setProperty('--rb-tint', c.tint || 'var(--rb-surface)');
      var img = el.querySelector('[data-rb-main]');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        var source = this.bedImg(b);
        if (img.getAttribute('src') !== source) img.src = source;
        img.alt = 'Sommier ' + b.title + ' — ' + c.name;
      }
      var cn = el.querySelector('[data-rb-color-name]'); if (cn) cn.textContent = c.name;
      var ci = el.querySelector('[data-rb-color-dot]');
      if (ci) { ci.style.background = c.swatchImg ? 'url(' + c.swatchImg + ')' : c.swatch; }
      el.querySelectorAll('[data-rb-color]').forEach(function (btn, i) {
        var a = i === (this.S.colors[b.id] || 0);
        var color = b.colors[i];
        var available = this.colorAvailable(color);
        btn.hidden = !available;
        btn.disabled = !available;
        var thumbnail = btn.querySelector('img');
        var sizedColor = this.colorForSize(color);
        var thumbnailSrc = sizedColor && (sizedColor.img || sizedColor.imgs[0]);
        if (thumbnailSrc) {
          if (!thumbnail) {
            thumbnail = document.createElement('img');
            thumbnail.alt = '';
            thumbnail.width = 80;
            thumbnail.height = 64;
            thumbnail.loading = 'lazy';
            btn.appendChild(thumbnail);
          }
          if (thumbnail.getAttribute('src') !== thumbnailSrc) thumbnail.src = thumbnailSrc;
        }
        btn.title = color ? color.name : btn.getAttribute('aria-label');
        btn.classList.toggle('is-on', a); btn.setAttribute('aria-pressed', a);
      }.bind(this));
      var swatches = el.querySelector('.rb-sw');
      if (swatches) {
        var count = b.colors.filter(color => this.colorAvailable(color)).length;
        var note = el.querySelector('[data-rb-color-count]');
        if (!note) {
          note = document.createElement('p');
          note.className = 'rb-color-count';
          note.setAttribute('data-rb-color-count', '');
          swatches.before(note);
        }
        note.hidden = !this.S.size;
        note.textContent = count + ' coloris disponible' + (count > 1 ? 's' : '') + ' en ' + (this.S.size || '').replace('x', ' × ') + ' cm';
      }

      var th = el.querySelector('[data-rb-thumbs]');
      el.querySelectorAll('[data-rb-gallery-step]').forEach(button => { button.hidden = c.imgs.length < 2; });
      var counter = el.querySelector('[data-rb-gallery-count]');
      if (counter) { counter.hidden = c.imgs.length < 2; counter.textContent = (k + 1) + ' / ' + c.imgs.length; }
      if (th) {
        var focusedPhoto = th.contains(document.activeElement) ? document.activeElement.getAttribute('data-rb-photo') : null;
        th.hidden = c.imgs.length < 2;
        var clips = this.clipsOf(b);
        var reel = '';
        var galleryKey = JSON.stringify(c.imgs);
        if (th.dataset.rbGalleryKey !== galleryKey) {
        th.dataset.rbGalleryKey = galleryKey;
        th.innerHTML = (c.imgs.length > 1 || reel)
          ? reel + c.imgs.map(function (src, i) {
              return '<button type="button" data-rb-photo="' + i + '" class="' + (i === k ? 'is-on' : '') + '" aria-label="Photo ' + (i + 1) + '"><img src="' + src + '" alt="" loading="lazy" decoding="async" width="80" height="64"></button>';
            }).join('')
          : '';
        }
        th.querySelectorAll('[data-rb-photo]').forEach(button => {
          var active = Number(button.dataset.rbPhoto) === k;
          button.classList.toggle('is-on', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (focusedPhoto !== null) {
          var restoreFocus = th.querySelector('[data-rb-photo="' + k + '"]');
          if (restoreFocus) restoreFocus.focus({ preventScroll: true });
        }
        var activeThumb = th.querySelector('.is-on');
        if (activeThumb) th.scrollLeft = Math.max(0, activeThumb.offsetLeft - th.offsetLeft - th.clientWidth / 2 + activeThumb.clientWidth / 2);
      }

      var v = this.bedVariant(b);
      var dimensionBox = el.querySelector('[data-rb-dimensions]');
      if (dimensionBox) {
        var dimensionSrc = v && v.dimensionImage;
        var dimensionText = v && v.dimensionText;
        dimensionBox.hidden = !dimensionSrc && !dimensionText;
        var dimensionLink = dimensionBox.querySelector('[data-rb-dimensions-link]');
        var dimensionImg = dimensionBox.querySelector('[data-rb-dimensions-image]');
        var dimensionLabel = dimensionBox.querySelector('[data-rb-dimensions-text]');
        dimensionLink.hidden = !dimensionSrc;
        if (dimensionSrc) {
          dimensionLink.href = dimensionSrc;
          if (dimensionImg.getAttribute('src') !== dimensionSrc) dimensionImg.src = dimensionSrc;
          dimensionImg.alt = 'Schéma des dimensions — ' + b.title + ' — couchage ' + this.S.size;
        } else {
          dimensionLink.removeAttribute('href');
          dimensionImg.removeAttribute('src');
        }
        dimensionLabel.hidden = !dimensionText;
        dimensionLabel.textContent = dimensionText ? 'Dimensions totales du lit : ' + dimensionText : '';
      }
      var express = el.querySelector('[data-rb-express]');
      if (express) express.hidden = !(v && v.available && !v.late);
      var price = el.querySelector('[data-rb-price]');
      if (price) price.textContent = v ? this.fmt(v.price) : '—';
      var compare = el.querySelector('[data-rb-compare]');
      var saving = el.querySelector('[data-rb-saving]');
      var onSale = !!(v && Number(v.compareAt) > Number(v.price));
      if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? this.fmt(v.compareAt) : ''; }
      if (saving) { saving.hidden = !onSale; saving.textContent = onSale ? 'Économisez ' + this.fmt(v.compareAt - v.price) : ''; }
      var stat = el.querySelector('[data-rb-stock]');
      if (stat && v) stat.innerHTML = '<span class="rb-dot' + (v.late ? ' rb-dot--w' : '') + '"></span>' + this.esc(v.stock || (v.late ? 'Sur commande' : 'En stock'));
      if (stat && !v) stat.textContent = '';

      el.classList.toggle('is-sel', on);
      var pk = el.querySelector('[data-rb-picked]');
      if (pk) pk.innerHTML = '<span aria-hidden="true">✓</span> Votre sommier · ' + this.esc(c.name);
      var mark = el.querySelector('[data-rb-select-mark]');
      if (mark) { mark.setAttribute('aria-pressed', String(this.S.bed === b)); mark.disabled = !v || !v.available; }
      var sb = el.querySelector('[data-rb-select]');
      if (sb) {
        sb.disabled = !v || !v.available;
        sb.textContent = on ? '✓ Sommier sélectionné' : 'Choisir ce sommier';
        sb.className = on ? 'rb-btn rb-btn--a rb-btn--w' : 'rb-btn rb-btn--g rb-btn--w';
        sb.setAttribute('aria-pressed', on);
      }
      this.prepareCompactCard(el, v);
    }

    paintMats() {
      var self = this;
      this.mats.forEach(function (m) {
        var on = self.S.mattress === m;
        m.el.classList.toggle('is-sel', on);
        var v = self.variant(m, self.S.size);
        var p = m.el.querySelector('[data-rb-price]'); if (p) p.textContent = v ? self.fmt(v.price) : '—';
        var sl = m.el.querySelector('[data-rb-size-label]'); if (sl) sl.textContent = self.S.size || '';
        var st = m.el.querySelector('[data-rb-stock]');
        if (st && v) st.innerHTML = '<span class="rb-dot' + (v.late ? ' rb-dot--w' : '') + '"></span>' + self.esc(v.stock || '');
        var mark = m.el.querySelector('[data-rb-select-mark]');
        if (mark) { mark.disabled = !v || !v.available; mark.setAttribute('aria-pressed', String(on)); }
        var sb = m.el.querySelector('[data-rb-select]');
        if (sb) sb.disabled = !v || !v.available;
        if (sb) { sb.textContent = on ? '✓ Matelas choisi — retirer' : 'Choisir ce matelas'; sb.className = on ? 'rb-btn rb-btn--a rb-btn--w' : 'rb-btn rb-btn--g rb-btn--w'; sb.setAttribute('aria-pressed', on); }
      });
      this.mats.forEach(m => this.prepareCompactCard(m.el, this.variant(m, this.S.size)));
      var grid = this.$('[data-rb-mattress-grid]'); if (grid) grid.classList.toggle('has-sel', !!this.S.mattress);
      var available = this.mats.some(m => this.variant(m, this.S.size)?.available);
      var empty = this.$('[data-rb-mattress-empty]');
      if (empty) { empty.hidden = available || !this.S.size; empty.textContent = 'Aucun matelas proposé en ' + (this.S.size || '').replace('x', ' × ') + ' cm pour le moment.'; }
      var skip = this.$('[data-rb-skip-mattress]');
      if (skip) { skip.textContent = 'Continuer sans matelas'; skip.className = this.S.skipM ? 'rb-btn rb-btn--a' : 'rb-btn rb-btn--g'; }
    }

    nightstandMatch(n) {
      if (!n.argo || !this.S.bed || !n.variant.available) return false;
      var norm = function (text) {
        return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
          .replace(/\b(tissu|tissus)\b/g, '').replace(/bouclette/g, 'boucle')
          .replace(/\bpu\b|simili[- ]?cuir/g, 'simili cuir')
          .replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
      };
      var selected = norm(this.col(this.S.bed).name);
      return !!selected && selected === norm(n.color);
    }

    paintNs() {
      var self = this;
      if (this.S.nsChoice === 'auto' && !this.restoringRoom) {
        var matches = this.nss.filter(n => this.nightstandMatch(n));
        matches.sort((a,b) => Number(a.variant.late) - Number(b.variant.late));
        this.S.ns = matches[0] || null;
        this.S.skipNs = false;
      }
      this.nss.forEach(function (n) {
        var recommended = self.nightstandMatch(n);
        n.recommended = recommended;
        var badge = n.el.querySelector('[data-rb-ns-recommend]');
        if (badge) badge.hidden = !recommended;
        var on = self.S.ns === n;
        var q = on ? self.S.nsQty : Number(n.el.dataset.rbCardQty || 1);
        n.el.dataset.rbCardQty = q;
        n.el.classList.toggle('is-sel', on);
        n.el.querySelectorAll('[data-rb-qty]').forEach(function (b) {
          var a = Number(b.dataset.rbQty) === q; b.classList.toggle('is-on', a); b.setAttribute('aria-pressed', a);
        });
        var v = self.nightstandVariant(n, q) || {};
        n.el.querySelectorAll('[data-rb-qty]').forEach(button => {button.disabled = !self.nightstandVariant(n, Number(button.dataset.rbQty))?.available;});
        var status = n.el.querySelector('.rb-stat');
        if (status) status.innerHTML = '<span class="rb-dot' + (v.late ? ' rb-dot--w' : '') + '"></span>' + self.esc(v.stock || '');

        var lbl = n.el.querySelector('[data-rb-qty-label]'); if (lbl) lbl.textContent = q + ' × ' + self.fmt(v.price);
        var p = n.el.querySelector('[data-rb-price]'); if (p) p.textContent = self.fmt((v.price || 0) * q);
        var mark = n.el.querySelector('[data-rb-select-mark]');
        if (mark) { mark.disabled = !v.available; mark.setAttribute('aria-pressed', String(on)); }
        var ab = n.el.querySelector('[data-rb-select]');
        if (ab) { ab.disabled = !v.available; ab.textContent = on ? '✓ Ajouté — retirer' : 'Ajouter'; ab.className = on ? 'rb-btn rb-btn--a rb-btn--w' : 'rb-btn rb-btn--g rb-btn--w'; ab.setAttribute('aria-pressed', on); }
      });
      this.nss.forEach(n => this.prepareCompactCard(n.el, this.nightstandVariant(n, Number(n.el.dataset.rbCardQty || 1))));
      var notice = this.$('[data-rb-ns-notice]');
      if (notice) {
        var chosen = this.S.ns, variant = chosen && this.nightstandVariant(chosen, this.S.nsQty);
        notice.hidden = !chosen;
        if (chosen) {
          var text = this.S.nsChoice === 'auto' ? this.S.nsQty + ' chevet(s) conseillé(s) ajouté(s) automatiquement : ' + chosen.title + '. Vous pouvez changer de modèle ou continuer sans chevets.' :
            (!this.nightstandMatch(chosen) && this.S.bed ? 'Vous conservez ' + chosen.title + '. Ce coloris ne correspond pas exactement au tissu et au coloris actuels du sommier.' : '');
          if (variant.late) text += ' ' + variant.stock + '. La livraison groupée attendra la disponibilité de cette quantité.';
          notice.textContent = text; notice.hidden = !text;
        }
      }
      var grid = this.$('[data-rb-ns-grid]');
      if (grid) {
        grid.classList.toggle('has-sel', !!this.S.ns);
        var ordered = this.nss.slice().sort(function (a,b) {
          return Number(b.argo)-Number(a.argo) || Number(b.recommended)-Number(a.recommended) ||
            Number(b.variant.available)-Number(a.variant.available) || Number(a.variant.late)-Number(b.variant.late);
        });
        if (!this.mobileDetail) ordered.forEach(function(n,i) { if (grid.children[i] !== n.el) grid.insertBefore(n.el, grid.children[i] || null); });
      }
    }

    /* ---------- total animé, une seule boucle ---------- */
    animate(to) {
      var t = this.$('[data-rb-total]'), d = this.$('[data-rb-dock-total]');
      if (this.rafId) { cancelAnimationFrame(this.rafId); this.rafId = null; }
      var set = (v) => { if (t) t.textContent = v; if (d) d.textContent = v; };
      if (!to) { set('—'); this.shown = 0; return; }
      if (RM.matches) { set(this.fmt(to)); this.shown = to; return; }
      var from = this.shown, t0 = performance.now(), self = this;
      var tick = function (now) {
        var k = Math.min(1, (now - t0) / 420), e = 1 - Math.pow(1 - k, 3);
        set(self.fmt(from + (to - from) * e));
        if (k < 1) self.rafId = requestAnimationFrame(tick);
        else { self.shown = to; self.rafId = null; set(self.fmt(to)); }
      };
      this.rafId = requestAnimationFrame(tick);
    }

    roomDiscounts(S, mp, np) {
      var matEligible = !!(S.bed && S.bed.mattressOffer && S.mattress && S.mattress.mattressOffer);
      var nsEligible = !!(S.ns && ["8672621953254","8675936207078","15160848515452","8672594264294","8672956711142","8672572539110","8672925450470","8672730775782","8672878297318","8672658325734","15769895010684","16102915670396","16102920323452","16102946046332","15479622631804","15479626596732","15479627809148","15479651926396","15479671390588","15479704519036","15479706550652","16107459477884","16107459969404","16107460395388","16107460886908","16107461345660","16107461673340","16107461869948","16107462066556","16107462623612","16107462918524"].includes(String(S.ns.productId || S.ns.id)));
      return { mattress: matEligible ? Math.round(mp * 0.10) : 0, nightstand: nsEligible ? Math.round((np / (S.nsQty || 1)) * 0.15) * (S.nsQty || 1) : 0 };
    }

    /* ---------- rafraîchissement global ---------- */
    update() {
      this.paintNs();
      var S = this.S;
      var bv = S.bed ? this.bedVariant(S.bed) : null;
      var mv = S.mattress ? this.variant(S.mattress, S.size) : null;
      var nv = S.ns ? this.nightstandVariant(S.ns, S.nsQty) : null;
      var bp = bv ? bv.price : 0, mp = mv ? mv.price : 0, np = nv ? nv.price * S.nsQty : 0;
      var items = [S.bed, S.mattress, S.ns].filter(Boolean);
      var n = items.length;
      var sub = bp + mp + np;
      var discounts = this.roomDiscounts(S, mp, np);
      var save = discounts.mattress + discounts.nightstand;
      var total = sub - save;

      var setTxt = (sel, v) => { var e = this.$(sel); if (e) e.textContent = v; };
      var setHtml = (sel, v) => { var e = this.$(sel); if (e) e.innerHTML = v; };
      setTxt('[data-rb-count]', n ? n + ' produit' + (n > 1 ? 's' : '') : '0 produit');

      /* lignes */
      this.line('bed', S.bed, bv, bp, S.bed ? 'Sommier ' + S.bed.title : 'Sommier',
        S.bed ? S.size + ' · ' + this.col(S.bed).name : (S.size ? 'À choisir en ' + S.size : 'À choisir — étape 2'),
        S.bed ? this.bedImg(S.bed) : null);
      this.line('mattress', S.mattress, mv, mp, S.mattress ? 'Matelas ' + S.mattress.title : 'Matelas',
        S.mattress ? S.size + ' · ' + (S.mattress.thick || '') : (S.skipM ? 'Vous avez déjà le vôtre' : 'Facultatif — étape 3'),
        S.mattress ? S.mattress.img : null);
      this.line('nightstand', S.ns, nv, np, S.ns ? S.nsQty + ' × Chevet ' + S.ns.title : 'Chevets',
        S.ns ? S.nsQty + ' × ' + this.fmt(nv.price) : (S.skipNs ? 'Sans chevets' : 'Facultatif — étape 4'),
        S.ns ? S.ns.img : null);

      /* scène */
      var main = this.$('[data-rb-stage-main]'), img = this.$('[data-rb-stage-img]'), empty = this.$('[data-rb-stage-empty]');
      var src = S.bed ? this.bedImg(S.bed) : S.mattress ? S.mattress.img : S.ns ? S.ns.img : null;
      if (src) { img.src = src; main.classList.add('is-in'); empty.hidden = true; }
      else { main.classList.remove('is-in'); empty.hidden = false; }
      setHtml('[data-rb-cap]', S.bed
        ? this.esc(S.bed.title) + ' · <i style="background:' + this.col(S.bed).swatch + '"></i>' + this.esc(this.col(S.bed).name) + ' · ' + this.esc(S.size)
        : (S.size ? 'Taille ' + this.esc(S.size) : ''));
      var tM = this.$('[data-rb-tile-m]'), tN = this.$('[data-rb-tile-n]');
      if (S.bed && S.mattress) { tM.querySelector('img').src = S.mattress.img; tM.classList.add('is-in'); } else tM.classList.remove('is-in');
      if (S.bed && S.ns) { tN.querySelector('img').src = S.ns.img; tN.classList.add('is-in'); } else tN.classList.remove('is-in');

      /* Offres natives Shopify : les remises portent seulement sur les accessoires éligibles. */
      [!!S.bed, !!discounts.mattress, !!discounts.nightstand].forEach((on, i) => {
        var e = this.$('[data-rb-tier="' + (i + 1) + '"]'); if (e) e.classList.toggle('is-on', on);
      });
      var offerLabels = [];
      if (discounts.mattress) offerLabels.push('Matelas −10 %');
      if (discounts.nightstand) offerLabels.push('Chevets −15 %');
      setTxt('[data-rb-tier-title]', save ? this.fmt(save) + ' d’économies' : 'Vos avantages');
      setTxt('[data-rb-tier-text]', save ? offerLabels.join(' · ') + '. Remises appliquées au panier.' : '−10 % sur un matelas avec un lit éligible. −15 % sur les chevets éligibles.');

      setTxt('[data-rb-subtotal]', sub ? this.fmt(sub) : '—');
      var rowSave = this.$('[data-rb-row-save]'); if (rowSave) rowSave.hidden = !save;
      setTxt('[data-rb-save-label]', offerLabels.join(' · '));
      setTxt('[data-rb-save]', '−' + this.fmt(save));
      this.animate(total);

      /* disponibilité */
      var pack = this.$('[data-rb-pack]'), ico = this.$('[data-rb-pack-ico]');
      var vars = [bv, mv, nv].filter(Boolean);
      pack.classList.remove('is-ok', 'is-late');
      if (!vars.length) { ico.textContent = '·'; setTxt('[data-rb-pack-title]', 'Disponibilité'); setTxt('[data-rb-pack-detail]', 'Elle s’affichera dès vos premiers choix.'); }
      else {
        var late = vars.filter(v => v.late), maxD = Math.max.apply(null, vars.map(v => v.days || 3));
        if (!late.length) {
          pack.classList.add('is-ok'); ico.textContent = '✓';
          setTxt('[data-rb-pack-title]', n > 1 ? 'Ensemble complet en stock' : 'En stock');
          setTxt('[data-rb-pack-detail]', 'Articles en stock. Livraison groupée ; délai confirmé lors de la commande.');
        } else {
          pack.classList.add('is-late'); ico.textContent = '!';
          var names = [S.bed && bv && bv.late ? S.bed.title : null, S.mattress && mv && mv.late ? S.mattress.title : null, S.ns && nv && nv.late ? S.ns.title : null].filter(Boolean);
          var list = names.length > 1 ? names.slice(0, -1).join(', ') + ' et ' + names.slice(-1) : names[0];
          setTxt('[data-rb-pack-title]', late.length + ' article' + (late.length > 1 ? 's' : '') + ' sur commande');
          var delayed = [[S.bed, bv], [S.mattress, mv], [S.ns, nv]].filter(pair => pair[0] && pair[1] && pair[1].late);
          setTxt('[data-rb-pack-detail]', delayed.map(pair => pair[0].title + ' : ' + (pair[1].stock || 'délai à confirmer')).join(' · ') + '. Livraison groupée après disponibilité de tous les articles.' + (late.length < vars.length ? ' Le reste est en stock.' : ''));
        }
      }

      /* bouton */
      var cta = this.$('[data-rb-add]');
      cta.disabled = this.cartBusy || !S.bed || !bv || !bv.available || !!(nv && !nv.available);
      var anotherRoom = this.$('[data-rb-another-room]');
      if (anotherRoom) { anotherRoom.disabled = cta.disabled; anotherRoom.hidden = !S.bed; }
      cta.textContent = !S.size ? 'Choisissez votre taille pour commencer'
        : !S.bed ? 'Choisissez votre sommier pour commencer'
        : 'Ajouter au panier · ' + this.fmt(total);
      var dock = this.$('[data-rb-dock]'); if (dock) dock.hidden = !n;
      setTxt('[data-rb-dock-label]', n ? n + ' produit' + (n > 1 ? 's' : '') + (save ? ' · offres incluses' : '') : 'Votre chambre');

      /* étapes */
      var steps = this.$$('[data-rb-step]');
      steps.forEach(s => { s.classList.remove('is-on', 'is-ok'); s.removeAttribute('aria-current'); });
      var mark = (i, done) => { if (!steps[i]) return; steps[i].classList.add(done ? 'is-ok' : 'is-on'); if (!done) steps[i].setAttribute('aria-current', 'step'); };
      mark(0, !!S.size);
      if (S.size) mark(1, !!S.bed);
      if (S.bed) mark(2, !!(S.mattress || S.skipM));
      if (S.mattress || S.skipM) mark(3, !!(S.ns || S.skipNs));
      setTxt('[data-rb-v="0"]', S.size || 'À choisir');
      setTxt('[data-rb-v="1"]', S.bed ? S.bed.title + ' · ' + this.col(S.bed).name : (S.size ? 'Au choix' : '—'));
      setTxt('[data-rb-v="2"]', S.mattress ? S.mattress.title : (S.skipM ? 'Sans matelas' : 'Facultatif'));
      setTxt('[data-rb-v="3"]', S.ns ? S.nsQty + ' × ' + S.ns.title : (S.skipNs ? 'Sans chevets' : 'Facultatif'));

      /* verrous */
      var has = !!S.size;
      this.classList.toggle('is-start', !has);
      this.classList.toggle('is-no-bed', !S.bed);
      ['#rb-step-bed', '#rb-step-mattress', '#rb-step-ns'].forEach(sel => { this.$(sel).hidden = !has; });
      setTxt('[data-rb-compact-size]', S.size ? S.size.replace('x', ' × ') + ' cm' : '');
      ['bed', 'mattress'].forEach(k => {
        var w = this.$('[data-rb-wait="' + k + '"]'), l = this.$('[data-rb-live-block="' + k + '"]');
        if (w) w.hidden = has; if (l) l.hidden = !has;
      });
      var st = this.$('[data-rb-size-tag]'); if (st) { st.hidden = !has; }
      setTxt('[data-rb-size-tag-v]', S.size || '');
      var sbar = this.$('[data-rb-sizebar]'); if (sbar) sbar.hidden = !has;
      setTxt('[data-rb-sizebar-v]', S.size || '');
      var nb = this.$('[data-rb-next-bed]'); if (nb) nb.hidden = !S.bed;
      var nm = this.$('[data-rb-next-mattress]'); if (nm) nm.hidden = !(S.mattress || S.skipM);
      var sn = this.$('[data-rb-skip-ns]'); if (sn) sn.hidden = !S.ns;
      this.mobileSummary();
      this.saveRoom();
    }

    line(kind, prod, v, price, title, sub, img) {
      var ln = this.$('[data-rb-line="' + kind + '"]'); if (!ln) return;
      var th = ln.querySelector('[data-rb-ln-th]');
      ln.classList.toggle('is-off', !prod);
      if (prod && img) th.innerHTML = '<img src="' + img + '" alt="">';
      else th.textContent = kind === 'bed' ? '1' : kind === 'mattress' ? '2' : '3';
      ln.querySelector('[data-rb-ln-title]').textContent = title;
      ln.querySelector('[data-rb-ln-sub]').textContent = sub;
      ln.querySelector('[data-rb-ln-price]').textContent = prod ? this.fmt(price) : '—';
      var st = ln.querySelector('[data-rb-ln-stock]');
      if (v) { st.textContent = v.stock || (v.late ? 'Sur commande' : 'En stock'); st.className = 'rb-ln__st ' + (v.late ? 'is-late' : 'is-ok'); }
      else { st.textContent = ''; st.className = 'rb-ln__st'; }
      ln.querySelector('[data-rb-del]').hidden = !prod;
    }

    /* ---------- panier ---------- */
    addToCart(composeAnother) {
      if (this.cartBusy) return;
      var S = this.S, self = this;
      if (!S.bed || !this.bedVariant(S.bed)?.available || (S.ns && !this.nightstandVariant(S.ns, S.nsQty)?.available)) {
        this.say('Vérifiez votre sommier et les quantités avant de continuer.'); return;
      }
      this.track('cart_attempt');
      var items = [];
      var push = (v, role) => { if (v && v.id) items.push({ id: v.id, quantity: role === 'chevet' ? S.nsQty : 1, properties: { _rb_id: this.roomId, _rb_role: role } }); };
      push(S.bed ? this.bedVariant(S.bed) : null, 'sommier');
      push(S.mattress ? this.variant(S.mattress, S.size) : null, 'matelas');
      push(S.ns ? this.nightstandVariant(S.ns, S.nsQty) : null, 'chevet');
      if (!items.length) return;

      var btn = this.$('[data-rb-add]'), err = this.$('[data-rb-error]');
      this.cartBusy = true; btn.disabled = true; this.mobileSummary();
      var another = this.$('[data-rb-another-room]'); if (another) another.disabled = true;
      btn.classList.add('is-busy'); btn.textContent = 'Ajout en cours…'; err.hidden = true;

      // Apply the code before adding products: a failed discount request cannot duplicate a room.
      return fetch(this.cartUrl.replace(/\/$/, '') + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: this.nightstandDiscountCode })
      }).then(function (r) {
        if (!r.ok) throw new Error('discount_request_failed');
        return fetch(self.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        self.cartBusy = false; btn.disabled = false; self.mobileSummary(); btn.classList.remove('is-busy');
        if (!res.ok) {
          err.textContent = res.j && res.j.description ? res.j.description : 'Un article n’est plus disponible. Rechargez la page et réessayez.';
          err.hidden = false; self.track('cart_error'); self.update();
          return;
        }
        self.track('cart_success');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (composeAnother === true) {
          self.restartRoom();
          var saved = self.$('[data-rb-room-saved]');
          if (saved) saved.hidden = false;
          self.track('another_room');
          self.say('Votre chambre a été ajoutée au panier. Choisissez la taille de votre prochaine chambre.');
        } else {
          window.location.href = self.cartUrl;
        }
      })
      .catch(function () {
        self.cartBusy = false; btn.disabled = false; self.mobileSummary(); btn.classList.remove('is-busy');
        err.textContent = 'La connexion a échoué. Réessayez dans un instant.';
        err.hidden = false; self.track('cart_error'); self.update();
      });
    }

    /* ---------- galerie ---------- */
    lbFocusables() {
      return Array.prototype.slice.call(this.$('[data-rb-lb]').querySelectorAll('button,a[href]')).filter(el => !el.hidden && el.offsetParent !== null);
    }
    lbMedia() {
      var b = this.LB.bed, c = this.col(b);
      return this.clipsOf(b).map(x => ({ t: 'reel', clip: x })).concat(c.imgs.map(src => ({ t: 'photo', src: src })));
    }
    openLb(bed, onVideo) {
      if (!bed) return;
      this.LB = { bed: bed, i: 0, opener: document.activeElement };
      var nR = this.clipsOf(bed).length;
      this.LB.i = onVideo && nR ? 0 : nR + this.photoIdx(bed);
      this.$('[data-rb-lb-link]').href = bed.url;
      this.cancelStepMotion();
      this.paintLb();
      this.$('[data-rb-lb]').classList.add('is-open');
      this.lbBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.$$('[data-rb-inert]').forEach(el => el.setAttribute('inert', ''));
      this.$('[data-rb-lb-close]').focus();
    }
    paintLb() {
      var thumbHadFocus = document.activeElement && document.activeElement.hasAttribute('data-rb-lb-thumb');
      var b = this.LB.bed, c = this.col(b), media = this.lbMedia(), nR = this.clipsOf(b).length;
      this.LB.i = ((this.LB.i % media.length) + media.length) % media.length;
      var m = media[this.LB.i];
      this.$('[data-rb-lb-title]').textContent = 'Sommier ' + b.title;
      this.$('[data-rb-lb-sub]').textContent = c.name + ' · ' + (nR ? nR + ' vidéo' + (nR > 1 ? 's' : '') + ' · ' : '') + c.imgs.length + ' photo' + (c.imgs.length > 1 ? 's' : '');
      var reel = this.$('[data-rb-lb-reel]'), img = this.$('[data-rb-lb-img]');
      if (m.t === 'reel') {
        img.hidden = true; reel.hidden = false;
        this.mountReel(reel, b, m.clip);
      } else {
        var playing = reel.querySelector('video'); if (playing) playing.pause();
        reel.replaceChildren();
        reel.hidden = true; img.hidden = false;
        img.src = m.src; img.alt = 'Sommier ' + b.title + ' — ' + c.name + ', photo ' + (this.LB.i - nR + 1);
      }
      var self = this;
      this.$('[data-rb-lb-thumbs]').innerHTML = media.map(function (x, i) {
        return x.t === 'reel'
          ? '<button type="button" data-rb-lb-thumb="' + i + '" class="rb-reel' + (i === self.LB.i ? ' is-on' : '') + '" aria-label="Vidéo"><img src="' + (x.clip.poster || c.imgs[0]) + '" alt=""></button>'
          : '<button type="button" data-rb-lb-thumb="' + i + '" class="' + (i === self.LB.i ? 'is-on' : '') + '" aria-label="Photo ' + (i - nR + 1) + '"><img src="' + x.src + '" alt=""></button>';
      }).join('');
      var track = this.$('[data-rb-lb-thumbs]');
      var activeThumb = track.querySelector('[data-rb-lb-thumb="' + this.LB.i + '"]');
      if (activeThumb) {
        activeThumb.setAttribute('aria-current', 'true');
        if (thumbHadFocus) activeThumb.focus({ preventScroll: true });
        var x = activeThumb.offsetLeft - track.offsetLeft - (track.clientWidth - activeThumb.clientWidth) / 2;
        track.scrollTo({ left: Math.max(0, x), behavior: RM.matches ? 'instant' : 'smooth' });
      }
      var counter = this.$('[data-rb-lb-counter]');
      if (!counter) {
        counter = document.createElement('span'); counter.className = 'rb-lb__counter';
        counter.setAttribute('data-rb-lb-counter', ''); counter.setAttribute('role', 'status');
        counter.setAttribute('aria-live', 'polite'); this.$('.rb-lb__stage').appendChild(counter);
      }
      counter.textContent = m.t === 'reel' ? 'Vidéo · ' + (this.LB.i + 1) + ' / ' + nR : 'Photo · ' + (this.LB.i - nR + 1) + ' / ' + c.imgs.length;
      var nav = media.length > 1;
      this.$('[data-rb-lb-prev]').hidden = !nav; this.$('[data-rb-lb-next]').hidden = !nav;
      var rev = this.$('[data-rb-lb-rev]');
      if (rev) rev.innerHTML = b.rating
        ? '<div><span style="color:var(--rb-gold)">' + this.stars(b.rating) + '</span> ' + String(b.rating).replace('.', ',') + '/5 · ' + b.reviews + ' avis vérifiés</div>'
          + (b.quote ? '<div>« ' + this.esc(b.quote.text) + ' »<b>' + this.esc(b.quote.author) + ' — achat vérifié</b></div>' : '')
        : '';
    }
    /* Lecture native : le fichier .mp4 vit sur le CDN Shopify, on le lit
       nous-mêmes avec une <video>. Repli sur la fiche produit si absent. */
    mountReel(host, bed, clip) {
      clearTimeout(this._reelT);
      host.innerHTML = '';

      if (!clip || !clip.src) {
        var fb = document.createElement('a');
        fb.className = 'rb-lb__fb';
        fb.href = bed.url; fb.target = '_blank'; fb.rel = 'noopener';
        fb.innerHTML = '<i aria-hidden="true">▶</i><b>Vidéo produit</b>'
          + '<u>Voir la vidéo sur la fiche produit ↗</u>';
        host.appendChild(fb);
        return;
      }

      var v = document.createElement('video');
      v.src = clip.src;
      if (clip.poster) v.poster = clip.poster;
      v.controls = true; v.autoplay = true; v.loop = true;
      v.playsInline = true; v.setAttribute('playsinline', '');
      v.preload = 'auto';
      v.setAttribute('aria-label', 'Vidéo ' + bed.title);
      v.addEventListener('error', function () {
        if (clip.fallback && v.getAttribute('src') !== clip.fallback) { v.src = clip.fallback; v.load(); return; }
        host.replaceChildren();
        var link = document.createElement('a'); link.href = bed.url;
        link.textContent = 'Vidéo indisponible. Ouvrir la fiche produit';
        host.appendChild(link);
      });
      host.appendChild(v);
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () { v.muted = true; v.play().catch(function () {}); });
    }

    /* compte-rendu lisible pour le personnalisateur */
    reelDiag() {
      var cat = this.reelCatalogue();
      return {
        REELUP: typeof window.REELUP,
        videosCatalogue: cat.size,
        sommiersAvecVideo: this.beds.filter(b => this.clipsOf(b).length).length,
        sommiers: this.beds.length
      };
    }

    closeLb() {
      clearTimeout(this._reelT);
      var r = this.$('[data-rb-lb-reel]');
      if (r) { r.innerHTML = ''; r.hidden = true; }
      this.$('[data-rb-lb]').classList.remove('is-open');
      document.body.style.overflow = this.lbBodyOverflow || '';
      this.$$('[inert]').forEach(el => el.removeAttribute('inert'));
      if (this.mobileDetail) this.lockMobileBackground();
      if (this.LB && this.LB.opener) this.LB.opener.focus();
    }
  });
})();

